import React from 'react';
import Card from '../components/ui/Card';
export default function Terms() {
  return <div className="w-full" data-id="element-583">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-light-grey py-16" data-id="element-584">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-585">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-heading mb-4" data-id="element-586">
            Terms & Conditions
          </h1>
          <p className="text-lg text-dark" data-id="element-587">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
          </p>
        </div>
      </section>
      {/* Content */}
      <section className="py-16 bg-white" data-id="element-588">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8" data-id="element-589">
          <Card data-id="element-590">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-591">Introduction</h2>
            <p className="text-dark mb-4" data-id="element-592">
              These Terms & Conditions govern your use of Artisanfix's reminder
              software service. By using our service, you agree to be bound by
              these terms.
            </p>
            <p className="text-dark" data-id="element-593">
              Please read these terms carefully before using our service. If you
              do not agree with any part of these terms, you should not use our
              service.
            </p>
          </Card>
          <Card data-id="element-594">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-595">
              Service Description
            </h2>
            <p className="text-dark mb-4" data-id="element-596">
              Artisanfix provides reminder software services that help users
              manage medication schedules and appointments through automated SMS
              text messages and phone calls.
            </p>
            <p className="text-dark mb-4" data-id="element-597">
              <strong data-id="element-598">Important:</strong> Artisanfix is a reminder tool only. It
              is not a medical service, healthcare provider, or insurance
              service. We do not provide medical advice, diagnosis, or
              treatment.
            </p>
            <p className="text-dark" data-id="element-599">
              Users are responsible for consulting with qualified healthcare
              professionals regarding all medical matters.
            </p>
          </Card>
          <Card data-id="element-600">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-601">
              Service Commencement
            </h2>
            <p className="text-dark mb-4" data-id="element-602">
              Your service begins immediately after payment is processed through
              Stripe, our secure payment provider.
            </p>
            <p className="text-dark" data-id="element-603">
              You will receive a confirmation email with instructions on how to
              access your account and set up reminders.
            </p>
          </Card>
          <Card data-id="element-604">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-605">
              Payment & Billing
            </h2>
            <p className="text-dark mb-4" data-id="element-606">
              All plans are billed annually in advance. Prices are displayed in
              British Pounds (£) and include VAT where applicable.
            </p>
            <p className="text-dark mb-4" data-id="element-607">
              Payments are processed securely through Stripe. By providing
              payment information, you authorise us to charge the applicable
              fees to your payment method.
            </p>
            <p className="text-dark" data-id="element-608">
              Your subscription will automatically renew at the end of each
              billing period unless you cancel before the renewal date.
            </p>
          </Card>
          <Card data-id="element-609">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-610">Refund Policy</h2>
            <p className="text-dark mb-4" data-id="element-611">
              We offer the following refund rights:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-612">
              <li data-id="element-613">
                <strong data-id="element-614">0–14 Days:</strong> Full refund, no questions asked.
                Simply contact us within 14 days of purchase
              </li>
              <li data-id="element-615">
                <strong data-id="element-616">After 14 Days:</strong> Refunds are at our discretion
                and will be considered on a case-by-case basis
              </li>
            </ul>
            <p className="text-dark mb-4" data-id="element-617">
              To request a refund, contact us at bhagatjenith3@gmail.com with
              your account details.
            </p>
            <p className="text-dark" data-id="element-618">
              Refunds will be processed within 5–10 working days to the original
              payment method.
            </p>
          </Card>
          <Card data-id="element-619">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-620">Cancellation</h2>
            <p className="text-dark mb-4" data-id="element-621">
              You may cancel your subscription at any time by contacting us at
              bhagatjenith3@gmail.com or through your account dashboard.
            </p>
            <p className="text-dark mb-4" data-id="element-622">
              There are no cancellation fees. Upon cancellation:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-623">
              <li data-id="element-624">
                Your service will remain active until the end of your current
                billing period
              </li>
              <li data-id="element-625">You will not be charged for subsequent billing periods</li>
              <li data-id="element-626">
                Your data will be deleted within 90 days unless otherwise
                requested
              </li>
            </ul>
          </Card>
          <Card data-id="element-627">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-628">
              User Responsibilities
            </h2>
            <p className="text-dark mb-4" data-id="element-629">By using Artisanfix, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-630">
              <li data-id="element-631">
                Provide accurate and complete information when setting up
                reminders
              </li>
              <li data-id="element-632">Ensure reminder times and medication details are correct</li>
              <li data-id="element-633">Keep your account login details secure and confidential</li>
              <li data-id="element-634">
                Notify us immediately of any unauthorised use of your account
              </li>
              <li data-id="element-635">Use the service in accordance with all applicable laws</li>
              <li data-id="element-636">
                Not use the service for any unlawful or prohibited purpose
              </li>
            </ul>
            <p className="text-dark" data-id="element-637">
              <strong data-id="element-638">Important:</strong> You are responsible for ensuring that
              all reminder information entered into the system is accurate.
              Artisanfix is not liable for any consequences arising from
              incorrect information provided by users.
            </p>
          </Card>
          <Card data-id="element-639">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-640">
              Service Availability
            </h2>
            <p className="text-dark mb-4" data-id="element-641">
              Whilst we strive to provide uninterrupted service, we cannot
              guarantee that the service will be available at all times. Service
              may be temporarily unavailable due to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-642">
              <li data-id="element-643">Scheduled maintenance</li>
              <li data-id="element-644">Technical issues beyond our control</li>
              <li data-id="element-645">Network or telecommunications failures</li>
              <li data-id="element-646">Force majeure events</li>
            </ul>
            <p className="text-dark" data-id="element-647">
              We will make reasonable efforts to notify users in advance of
              planned maintenance.
            </p>
          </Card>
          <Card data-id="element-648">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-649">
              Limitation of Liability
            </h2>
            <p className="text-dark mb-4" data-id="element-650">
              To the maximum extent permitted by law, Artisanfix's liability is
              limited to the amount of fees paid by you for the service in the
              12 months preceding the event giving rise to the claim.
            </p>
            <p className="text-dark mb-4" data-id="element-651">We are not liable for:</p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-652">
              <li data-id="element-653">Any indirect, incidental, or consequential damages</li>
              <li data-id="element-654">Loss of profits, data, or business opportunities</li>
              <li data-id="element-655">
                Damages arising from user error or incorrect information
                provided by users
              </li>
              <li data-id="element-656">
                Missed reminders due to network failures, device issues, or user
                error
              </li>
              <li data-id="element-657">
                Any health-related consequences resulting from use or non-use of
                the service
              </li>
            </ul>
            <p className="text-dark mb-4" data-id="element-658">
              <strong data-id="element-659">
                Nothing in these terms excludes or limits our liability for:
              </strong>
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark" data-id="element-660">
              <li data-id="element-661">Death or personal injury caused by our negligence</li>
              <li data-id="element-662">Fraud or fraudulent misrepresentation</li>
              <li data-id="element-663">Any other liability that cannot be excluded by law</li>
            </ul>
          </Card>
          <Card data-id="element-664">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-665">
              Intellectual Property
            </h2>
            <p className="text-dark mb-4" data-id="element-666">
              All content, features, and functionality of the Artisanfix
              service, including but not limited to text, graphics, logos, and
              software, are owned by Artisanfix and are protected by copyright,
              trademark, and other intellectual property laws.
            </p>
            <p className="text-dark" data-id="element-667">
              You may not copy, modify, distribute, or create derivative works
              based on our service without our express written permission.
            </p>
          </Card>
          <Card data-id="element-668">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-669">
              Data Protection
            </h2>
            <p className="text-dark mb-4" data-id="element-670">
              We process your personal data in accordance with our Privacy &
              Cookie Policy and UK GDPR regulations.
            </p>
            <p className="text-dark" data-id="element-671">
              Please refer to our Privacy & Cookie Policy for detailed
              information about how we collect, use, and protect your data.
            </p>
          </Card>
          <Card data-id="element-672">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-673">
              Modifications to Service
            </h2>
            <p className="text-dark mb-4" data-id="element-674">
              We reserve the right to modify, suspend, or discontinue any part
              of the service at any time. We will provide reasonable notice of
              significant changes.
            </p>
            <p className="text-dark" data-id="element-675">
              If we make material changes that negatively affect your use of the
              service, you may cancel your subscription and receive a pro-rata
              refund for the unused portion of your subscription.
            </p>
          </Card>
          <Card data-id="element-676">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-677">Termination</h2>
            <p className="text-dark mb-4" data-id="element-678">
              We may terminate or suspend your account and access to the service
              immediately, without prior notice, if:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-dark mb-4" data-id="element-679">
              <li data-id="element-680">You breach these Terms & Conditions</li>
              <li data-id="element-681">You engage in fraudulent or illegal activity</li>
              <li data-id="element-682">
                Payment fails and is not resolved within a reasonable timeframe
              </li>
            </ul>
            <p className="text-dark" data-id="element-683">
              Upon termination, your right to use the service will cease
              immediately. All provisions of these terms that by their nature
              should survive termination shall survive.
            </p>
          </Card>
          <Card data-id="element-684">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-685">Governing Law</h2>
            <p className="text-dark mb-4" data-id="element-686">
              These Terms & Conditions are governed by and construed in
              accordance with the laws of England and Wales.
            </p>
            <p className="text-dark" data-id="element-687">
              Any disputes arising from these terms or your use of the service
              shall be subject to the exclusive jurisdiction of the courts of
              England and Wales.
            </p>
          </Card>
          <Card data-id="element-688">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-689">
              Changes to Terms
            </h2>
            <p className="text-dark mb-4" data-id="element-690">
              We may update these Terms & Conditions from time to time. We will
              notify you of any material changes by email or through a notice on
              our site.
            </p>
            <p className="text-dark" data-id="element-691">
              Your continued use of the service after changes are made
              constitutes acceptance of the updated terms. If you do not agree
              to the changes, you should cancel your subscription.
            </p>
          </Card>
          <Card data-id="element-692">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-693">
              Contact Information
            </h2>
            <p className="text-dark mb-4" data-id="element-694">
              If you have any questions about these Terms & Conditions, please
              contact us:
            </p>
            <ul className="space-y-2 text-dark" data-id="element-695">
              <li data-id="element-696">
                <strong data-id="element-697">Email:</strong> bhagatjenith3@gmail.com
              </li>
            </ul>
          </Card>
          <Card data-id="element-698">
            <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-699">
              Entire Agreement
            </h2>
            <p className="text-dark" data-id="element-700">
              These Terms & Conditions, together with our Privacy & Cookie
              Policy, constitute the entire agreement between you and Artisanfix
              regarding the use of our service and supersede any prior
              agreements.
            </p>
          </Card>
        </div>
      </section>
    </div>;
}